/* src/app/pto-policy/setup-presenter/setup-presenter.component.scss */
.invalid {
  line-height: 0 !important;
}
.invalid-button-border {
  border: 2px solid #dc3545;
  border-radius: 6px;
}
.radio-label {
  margin-bottom: 0;
}
body#themeTag :host ::ng-deep .p-dialog.p-component.p-dialog-draggable.p-dialog-resizable {
  min-width: 30em !important;
}
body#themeTag :host ::ng-deep .tabulator-header-filter {
  height: 2.1em;
}
body#themeTag :host ::ng-deep .p-multiselect.p-component {
  height: 2.1em !important;
}
/*# sourceMappingURL=setup-presenter.component.css.map */
